import PricingTable from "./PricingTable";
import pricingTableAdapter from "./pricing-table.adapter";

export default PricingTable;
export { pricingTableAdapter };
